export enum NavigateRole {
  DEFAULT = 'back-to-root',
  GO_FORWARD = 'go-forward',
  CANCEL_REGISTER = 'cancel-register',
  EXPIRED = 'expired',
  SUCCESS = 'success',
  REJECTED = 'rejected',
  NDID_FAIL = 'ndid-fail',
  ERROR = 'error',
  OCR_FAIL = 'ocr-document-failed',
  DOPA_FAIL = 'dopa-document-failed',
  FACE_FAIL = 'face-document-failed',
  OCR_WARNING = 'ocr-document-warning',
  DOPA_WARNING = 'dopa-document-warning',
  FACE_WARNING = 'face-document-warning',
  CLOSE_KYC_WARNING = 'close-kyc-warning',
  VERSION_WARNING = 'version-warning',
  ERROR_WARNING = 'error-warning',
  START_KYC = 'start-kyc',
  REFRESH = 'refresh-page',
  CLOSE = 'close',
  SM_FAILED = 'sm-failed',
  FORCE_RESUME_WITH_TYPE = 'force-resume-with-type',
  LIMIT_POLICY_WARNING = 'limit-policy-warning',
  LIMIT_POLICY_FAIL = 'limit-policy-failed',
  CLIENT_FAIL = 'client-failed',
  DEBUG = 'debug', // for mornitor bug
  COMPLETED_ON_ANOTHER_DEVICE = 'completed-on-another-device'
}
